import React from "react";
import { Link } from "react-router-dom";
const Sidebar = () => {

const clickSidebarToggal = (e) => {
    e.preventDefault();

    if(!document.querySelector("#page-top").classList.contains('sidebar-toggled')){
        document.querySelector(".sidebar").classList.add('toggled');
        document.querySelector("#page-top").classList.add('sidebar-toggled');
    }
    else {
        document.querySelector(".sidebar").classList.remove('toggled');
        document.querySelector("#page-top").classList.remove('sidebar-toggled');
    }
    
}

    return (
        <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
            <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/admin/dashboard">
                <div className="sidebar-brand-icon">
                    <img src={"/frontend/images/logo@3x.png"} className="img-responsive" alt="DirtMap" height="70" width="100"/>
                </div>
                {/* <div className="sidebar-brand-text mx-3">
                    <img src={"/frontend/images/logo.png"} alt="DirtMap"/>
                </div> */}
            </Link>
            <li className="nav-item">
                <Link className="nav-link" to="/admin/dashboard">
                    <i className="fa fa-home fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Dashboard</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/admin/sub-admin/index">
                    <i className="fa fa-users fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Sub Admin</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/admin/user/index">
                    <i className="fa fa-users fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Users</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/admin/post-site/index">
                <i className="fa fa-globe fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Listings</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/admin/page/index">
                <i className="fas fa-file fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Cms Pages</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link" to="/admin/contact/list">
                <i className="fas fa-address-book fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Contact Us</span>
                </Link>
            </li>
            
            {/* <li className="nav-item">
                <Link className="nav-link" to="{{ route('category.index') }}">
                    <img src="{{ asset('images/dashboard-icon/categories.png') }}" width="14%" />
                    <span>Categories</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="{{ route('job.index') }}">
                    <i className="fa fa-tasks fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Jobs</span>

                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link collapsed" to="#" data-toggle="collapse" data-target="#collapseTwo"
                    aria-expanded="true" aria-controls="collapseTwo">
                    <i className="fa fa-tasks fa-3x text-gray-100" aria-hidden="true" width="14%"></i>
                    <span>Job Section</span>
                </Link>
                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div className="bg-white py-2 collapse-inner rounded">
                        <Link className="collapse-item" to="{{ route('category.index') }}">Categories</Link>
                        <Link className="collapse-item" to="{{ route('job.index') }}">Jobs</Link>
                    </div>
                </div>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="{{ route('blog.index') }}">
                    <i className="fas fa-blog fa-3x text-gray-100" width="14%"></i>
                    <span>Blogs</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="{{ route('announcement.index') }}">
                    <i className="fas  fa-bullhorn fa-3x text-gray-100" width="14%"></i>
                    <span>Announcements</span>
                </Link>
            </li> */}
            {/* <li className="nav-item">
                <Link className="nav-link" to="{{ route('faq.index') }}">
                    <i className="fas fa-question-circle fa-3x text-gray-100" width="14%"></i>
                    <span>Faqs</span>
                </Link>
            </li> */}
            {/* <li className="nav-item">
                <Link className="nav-link" to="{{ route('page.index') }}">
                    <i className="fas fa-file fa-3x text-gray-100" width="14%"></i>
                    <span>Pages</span>
                </Link>
            </li> */}

            <div className="text-center d-none d-md-inline">
                <button onClick={clickSidebarToggal} className="rounded-circle border-0" id="sidebarToggle"></button>
            </div>
        </ul>

    )
}
export default Sidebar;